module.exports = __webpack_public_path__ + "static/media/liberty.aa1fc564.png";